module.exports = __webpack_public_path__ + "img/pt-header.8db090c0.png";